<template>
  <DepartmentAbout
    :heading="data.heading || ''"
    :text="data.text || ''"
    :stats="data.stats || []"
  />
</template>

<script>
import DepartmentAbout from '@/components/Departments/DepartmentAbout.vue';

export default {
  name: 'AppDepartmentAboutBlock',
  components: { DepartmentAbout },
  props: {
    data: { type: Object, default: () => ({}) },
  },
};
</script>
